import type { JSX } from 'react';

import { addFormatter } from 'components/formatted-content/FormattedContent';

addFormatter('line-breaks', {
	selector: /([\n\r]{1})/g,
	defaultIgnored: false,
	decorator: (guid: string): JSX.Element => <br key={guid} />,
});
